<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands =
          [
              {
            "num_cand": "U2FsdGVkX18uuh7n2OHqaLON1lZXfhAqlEaxO+JhXSI=",
            "cpf": "U2FsdGVkX18G82LyE7Op4yZFoTiaIzeZmlOuyuMux5s="
          }, {
            "num_cand": "U2FsdGVkX1++REVoz46x2eUURR8thzdshLsHY4m8F8M=",
            "cpf": "U2FsdGVkX1/LhU5yyr76sZl4SbQfHe7zbyXgxLEIgoM="
          }, {
            "num_cand": "U2FsdGVkX18zq9AvTwo4CVTTRpf/WbdN9m/vbi6MXcA=",
            "cpf": "U2FsdGVkX19rg1FgkDefohLIAC01MrHcDYdNXpjTKWo="
          }, {
            "num_cand": "U2FsdGVkX18bJ1XtPzYv/owXRpq8CMLYLa0FC8bfecw=",
            "cpf": "U2FsdGVkX1+7ee0vt6ZH8ZbHL03x6GvVmoW5Wo5UIOM="
          }, {
            "num_cand": "U2FsdGVkX18luA8Lpfm36tv+v4v1ifiJQbcjDcY2cF8=",
            "cpf": "U2FsdGVkX1/ms3ZV3h7Tbm01/JZ9BrEy4fs/xLnyS4Y="
          }, {
            "num_cand": "U2FsdGVkX1/nLRFFrxhtRXX9Og5CrkHUqCv9iCJYu1o=",
            "cpf": "U2FsdGVkX19V0Kz5sreEBB6yOfq/lVCLXRkn1AyZlps="
          }, {
            "num_cand": "U2FsdGVkX18xJufY4yl83i39wDw6lE/oI0ponPBfttA=",
            "cpf": "U2FsdGVkX1+jOzPj3GKjXd0fGPfsJZwf3GRLqecnHP0="
          }, {
            "num_cand": "U2FsdGVkX1/gj/+hmZnvttH+y2BXa2UuWQkWtp+MtMI=",
            "cpf": "U2FsdGVkX1+OiPcKyeankWc5GaFeA7tT6Ied/6CbwEo="
          }, {
            "num_cand": "U2FsdGVkX1/iqKzdxZMf3aJAARdE2NJAiLnioyyIe5M=",
            "cpf": "U2FsdGVkX1+im+IW0E7wzaHrhfGhrM9+KfTJtltPQLU="
          }, {
            "num_cand": "U2FsdGVkX1/v7K6E0jM70MGQiGqGClP3XYgRatYDl5E=",
            "cpf": "U2FsdGVkX19ayIsqe1QrCHERcTNupLC2JSnI8fvS9Rk="
          }, {
            "num_cand": "U2FsdGVkX18zIPKpKUz1GAFDwusAsGN3MZBp7dU6no8=",
            "cpf": "U2FsdGVkX1/Q/QyI3Yul/NigNmU2eV/GOSbj77n8G1s="
          }, {
            "num_cand": "U2FsdGVkX1+AFZIQzOs6QAIHmFXy/u4LpWE1ii2ZJPQ=",
            "cpf": "U2FsdGVkX1+F98yvLgGh70d5+KuJZ7DOV40/rIw/0Cc="
          }, {
            "num_cand": "U2FsdGVkX1+NJiYM0VFtsXbhcdg7KErA4Jdyf0VFY/w=",
            "cpf": "U2FsdGVkX1+szZbUoUA/5Oml2a3cmoPtxE7tghFjaEQ="
          }, {
            "num_cand": "U2FsdGVkX1/pG/ZHJl/hvIenrMYxogdTKyI6Al5rZPA=",
            "cpf": "U2FsdGVkX18jaUeFoZF5AwxMw7jmT3hi6X+Utx304Gs="
          }, {
            "num_cand": "U2FsdGVkX1+A5IY6H0fopQ7G40orjE0JFUUVRUa6CUU=",
            "cpf": "U2FsdGVkX1/IQH5sezSL3nOUlNVNUR043OAsCnxhoIc="
          }, {
            "num_cand": "U2FsdGVkX19TMoGEk7Wr4vSyG4m32V+zD82jH+KOHXQ=",
            "cpf": "U2FsdGVkX19AbMAbnKP/KL+oA2rQeDsW7PYPWuAHl8g="
          }, {
            "num_cand": "U2FsdGVkX18cqwYV4iqdS2AFuKszVqKKe569Bc5Afho=",
            "cpf": "U2FsdGVkX18t8aQSO5F9rDepxLvhrnwUnuoLr7kXGlQ="
          }, {
            "num_cand": "U2FsdGVkX1+7MGcVENtaYrHiSsIh9copqX8hhsLixrM=",
            "cpf": "U2FsdGVkX18/2kwSCZBVhvGvocEP8b9BGrkeK3Y7L9o="
          }, {
            "num_cand": "U2FsdGVkX19QJpYFWlBcatazByKgD3X3saEzUfa352Y=",
            "cpf": "U2FsdGVkX18AXi6HnpEkJrJA2U+xLgVRIixuZvoktZk="
          }, {
            "num_cand": "U2FsdGVkX1+0rDiHsuN9/uSGs48U0l2GY0fsSsNNOj8=",
            "cpf": "U2FsdGVkX19JIzWBHCEuKz8qFLk1j3dKbMbTMJHkNJY="
          }, {
            "num_cand": "U2FsdGVkX1/ZWSw5Z5E/bUKB/Cg81aGg0VQIF04JOlA=",
            "cpf": "U2FsdGVkX1/c/JDHfCD4ZICpK5sCetG0Hu7nepbe0iE="
          }, {
            "num_cand": "U2FsdGVkX19MJGIQ9FqEHL1sHMAW8GqrM6W5ZMZAvIk=",
            "cpf": "U2FsdGVkX1/WA5J9nk6eNfvYgQV9lrSzCVgIcWFR/KM="
          }, {
            "num_cand": "U2FsdGVkX19Svw3Tj31TWUNKBO7p0F/tMMbAr0pYsEg=",
            "cpf": "U2FsdGVkX1/RVoBAk1V0p/Yd0E6gUfP8lXyy+/8jCRM="
          }, {
            "num_cand": "U2FsdGVkX18MuTivln7Oxd+cMLy5h2fp4c0r7s7IlTM=",
            "cpf": "U2FsdGVkX18o18G4rP1VY+8K/287EO0ZKhMK7IKjAhk="
          }, {
            "num_cand": "U2FsdGVkX19w+tuyNz90zPgwswhHm5q8pO5MDbbNHkk=",
            "cpf": "U2FsdGVkX1+vPbgl0Lv4XWNxRhpz+YVAVJno1wXz380="
          }, {
            "num_cand": "U2FsdGVkX18cJ254ixnq7x+CNfpvGPtjgPr5P1QbDCg=",
            "cpf": "U2FsdGVkX18PzIf+X6j3w6e28z27E5AXHBAujt/KDPs="
          }, {
            "num_cand": "U2FsdGVkX18qvtXYEP67ufPPDKImv3EW6v5HYJYQmNs=",
            "cpf": "U2FsdGVkX19QszF6kSadS/QOPX4j1J48E40EyVpKXiM="
          }, {
            "num_cand": "U2FsdGVkX19six11PzFfdligfrM7R89zlsI7gC/wFvE=",
            "cpf": "U2FsdGVkX18EwVcQqkQd13WFEb7ow8P3Gv9hZs0sdQY="
          }, {
            "num_cand": "U2FsdGVkX1+fQ7zYBPzkr+JkEtTku1khmGD1/gPmiXI=",
            "cpf": "U2FsdGVkX18+Gk2RhhO03B/m6WaV3I2SqFZNuW2LaBM="
          }, {
            "num_cand": "U2FsdGVkX1/hYN9yvJyA3TqsaikxsEOpbuBo534SaYw=",
            "cpf": "U2FsdGVkX19h9LPvCCAZUU/7gH6LYh8ansACITkBFuw="
          }, {
            "num_cand": "U2FsdGVkX19i/KzpG7LRLt4C4WToEONAQJ+mxkvkIWg=",
            "cpf": "U2FsdGVkX1/J+rBhTO6xSxYfr79wkiOlDp7YAL2HTw0="
          }, {
            "num_cand": "U2FsdGVkX1/6K9eg/3odffc8txwgE8BIF4Wzc0a0bI0=",
            "cpf": "U2FsdGVkX1/6GHmRhN8qeRX3dSnfzdt+/KAPUjnLvuE="
          }, {
            "num_cand": "U2FsdGVkX1+ADaQetW6RARn6LFR69UsElq3zM7HOTeI=",
            "cpf": "U2FsdGVkX1/sLElKUE/rDIE3EPqdzpZ94OFyrdwyyQc="
          }, {
            "num_cand": "U2FsdGVkX19EhZazsHWiz6D3DFnhjQREu2OsuRTXzQI=",
            "cpf": "U2FsdGVkX18akz6hLGGrvG91vgv7y3CdKtu6yGokny0="
          }, {
            "num_cand": "U2FsdGVkX18Gm0a/z6sI1QIL90oos5y+2EB+s0pv9H4=",
            "cpf": "U2FsdGVkX1/cL5QNq8v4FGxj2oJx9vAiWSLeZpkxFF4="
          }, {
            "num_cand": "U2FsdGVkX1/VxtJxEDdJaiXSjlSQLqjb8gkEka7BFUs=",
            "cpf": "U2FsdGVkX18pSwFeVTlOUKLWj8ecPzfYy5xSSAcQlGM="
          }, {
            "num_cand": "U2FsdGVkX1+P534a4rNN7v0EplLKLcSspbNTLQH3maI=",
            "cpf": "U2FsdGVkX18hdEUJawNFCsmwDW22t18GG6rVvoxbGGM="
          }, {
            "num_cand": "U2FsdGVkX18MpWqVcMRvrv4d4ArYMiB1hLvtuNFP5Hk=",
            "cpf": "U2FsdGVkX19zVrICKYNJsqD7keApSGJxs/krpxqsr2E="
          }, {
            "num_cand": "U2FsdGVkX199Z98vYS1+QuxAcaAkSHzx6lGbGQzaF0g=",
            "cpf": "U2FsdGVkX18wgGoN0wmX8QehBh3ct7hQC2HnRRRhNxM="
          }, {
            "num_cand": "U2FsdGVkX1+2i7kN6gJEX1Qu/zDl7aIcrvf6YOeuL/Y=",
            "cpf": "U2FsdGVkX1+9T/8Zg2YLphZmFnY+Bo7WiX11kBZrd3I="
          }, {
            "num_cand": "U2FsdGVkX1+4pdNcrwNxK8HaJTWj6x7QI23MCW+23zI=",
            "cpf": "U2FsdGVkX18mLW7iqHuhQ9aUfRvhfd6DsARWcGaWb+g="
          }, {
            "num_cand": "U2FsdGVkX1+RhZzQRWIhnWMCnR06qviOgXc1qbwk4RQ=",
            "cpf": "U2FsdGVkX1+z8kKTGJdgvcgTI7f4t7Ff6jKFxH46Tz0="
          }, {
            "num_cand": "U2FsdGVkX1/HYbMNex40cHIv2/oOy58DxFOOqCZ/I/8=",
            "cpf": "U2FsdGVkX1/UeqvArCfzsBEUsS33KBM8uuTusI+10ZM="
          }, {
            "num_cand": "U2FsdGVkX18/4tbxxUFyMGDiEeQjbomUatLrzfF70r4=",
            "cpf": "U2FsdGVkX1/hkNk445UQuTspPhbmQo9AFPmXO4GElRw="
          }, {
            "num_cand": "U2FsdGVkX1/AVQ94DWw2dZR8TcNsniU6gaG1JWmPXvk=",
            "cpf": "U2FsdGVkX18eVhwtYlL4ghFnDP4bk9GuFiAXqoFlly8="
          }, {
            "num_cand": "U2FsdGVkX18+GKhW1kSsmu4Ln0svgDhXps6QNjP1kbU=",
            "cpf": "U2FsdGVkX1+4ndaCdG04S7Fa/kLJ0BzcXXRReSSvJOk="
          }, {
            "num_cand": "U2FsdGVkX1+a1OcoRkGzfyjg0r0DLX8kxW6UECPHQwo=",
            "cpf": "U2FsdGVkX1/kNXUOcbdIvZXRAdaSL/Rm2ttmmhM4ulI="
          }, {
            "num_cand": "U2FsdGVkX19C/CzwgqwnN4jDpqboOdXgrtVYHUby8vs=",
            "cpf": "U2FsdGVkX18Zehb7ddQwTgaGc8Q8AHLKlarQ6VnW5aw="
          }, {
            "num_cand": "U2FsdGVkX197A4WymHeSNB8hZGplktxdNewBkpN5N6A=",
            "cpf": "U2FsdGVkX1/T0vXTChI7E2410NCCHYrv+p9m0ntFWek="
          }, {
            "num_cand": "U2FsdGVkX18bXVbSx6WjynT5vS87X81iJADrezZEIYY=",
            "cpf": "U2FsdGVkX19WMh7wKsJYeUXeg9Sn1hFSxyHEoCmL2Pw="
          }, {
            "num_cand": "U2FsdGVkX18oOam5dtdsY4RbbdXHTy6t+2F/t4L5Bto=",
            "cpf": "U2FsdGVkX1/J4PWkk+uJY81ShiFUDI4fSzPrd6NWkTA="
          }, {
            "num_cand": "U2FsdGVkX1/ajY0Iyb2AFvgmVVSlk9zfEULKgbVqn3g=",
            "cpf": "U2FsdGVkX18UJzgTch49iF14bYGfnpOZnx00Lgm76jA="
          }, {
            "num_cand": "U2FsdGVkX18ce7HxJq78E3O/FSzqKL9NLt9TOJR+alc=",
            "cpf": "U2FsdGVkX18Kztuq1uW0mirDlv2fGJx1uDr/he/6xSQ="
          }, {
            "num_cand": "U2FsdGVkX186BLpBUMp+m5qwN1vnptMWM2jeCjP4KW4=",
            "cpf": "U2FsdGVkX18elKrbdXXs0hocBzb6yIVHI1K3fH9+Ypw="
          }, {
            "num_cand": "U2FsdGVkX1+0fg1V/9fjwSi6VPdsCk4lbJyEQYsqqLg=",
            "cpf": "U2FsdGVkX199l2dD0/v5bNOfZeBPJwp9kYURsK8MZO0="
          }, {
            "num_cand": "U2FsdGVkX18RPRsTEz13fpDc7eRURYwGiCSFnu7kYlo=",
            "cpf": "U2FsdGVkX1+U1R9GGS0jTGP6nUwQGPewEaL8FurPs9E="
          }, {
            "num_cand": "U2FsdGVkX19sjgP6qEvDBvUdJ0Cj4wM5EsccUumWWpY=",
            "cpf": "U2FsdGVkX1+mk0KdGxHNo4K+iGzmf50pYT/akqcrWt4="
          }, {
            "num_cand": "U2FsdGVkX19PkSlhQFuFeWEUZWTvGnLktbRClTdh4zM=",
            "cpf": "U2FsdGVkX1/A4OBNZgl9yIzF4FHU8uW1QViNGs3zykU="
          }, {
            "num_cand": "U2FsdGVkX1+iJ1oxJn9IiLRGDnn6qSPx1a9ah95Q+FU=",
            "cpf": "U2FsdGVkX1/LO02J7N1EdMJfHfAKv0j1TbszOxIeuFE="
          }, {
            "num_cand": "U2FsdGVkX1+6+ufGjtPhQspms7unE8cXQ3FP3pGKzXs=",
            "cpf": "U2FsdGVkX18p6bUX5VqmJFtSQ0AxqNczS8tQ17BE+WY="
          }, {
            "num_cand": "U2FsdGVkX1+jMstDmCWIzPdDc6wxkZX6dQst2uHwEgw=",
            "cpf": "U2FsdGVkX18pWTmhs+MPtbY6G2nCqj5Jnfi5K5BQils="
          }, {
            "num_cand": "U2FsdGVkX1/fIY9W9O9K+mWM/sCLqQlsoOVqEbWUk/E=",
            "cpf": "U2FsdGVkX18LHr8Iny95kenCfjWDwvnE5BWKDZFfL6A="
          }, {
            "num_cand": "U2FsdGVkX1/zp9LFIcFNVihj2yYtolxh0c0D0dVyv/0=",
            "cpf": "U2FsdGVkX1+HtFoqYOLDHisB2vxyHmMqTxwmv6v4Y1E="
          }, {
            "num_cand": "U2FsdGVkX1/BREGnu5ytxyDS4vk7twgryLelf0I7XZ0=",
            "cpf": "U2FsdGVkX1+JMzkQySUgM7aEkCtLk9hVVHpa4fj2rxI="
          }, {
            "num_cand": "U2FsdGVkX1+Sd0h0q5PnTSl5Raz3/LzSnomYa90KyBI=",
            "cpf": "U2FsdGVkX1+cu7t1pLWH5dYIudPcP2mWuPCC4LGto/U="
          }, {
            "num_cand": "U2FsdGVkX1/+xfL3h6hGD0Z/ht45LJZ6Lo2IxGzvjww=",
            "cpf": "U2FsdGVkX19cRRAPU2AVcImDov72YyAYFAVFvwLnA2E="
          }, {
            "num_cand": "U2FsdGVkX1+hXtV4f3AKuk8yh4RqpwTigwh/gDhzCks=",
            "cpf": "U2FsdGVkX19PEJTugI3jUi+iUxQsHiI0pce+yAxOFx4="
          }, {
            "num_cand": "U2FsdGVkX1/pp6pQ63unDdqNMPoMfpZI1WzZ+6R+PgI=",
            "cpf": "U2FsdGVkX1/9Isr2U0Y8lDZqOyLLk/WgMlm++9qKSyc="
          }, {
            "num_cand": "U2FsdGVkX1+/5DbXCMnLsBpNnpKxAGYLjJr7wKpnXqY=",
            "cpf": "U2FsdGVkX195HYISoOsSdXrwIw2u7wgfbIyGA40uxKM="
          }, {
            "num_cand": "U2FsdGVkX1+TrdA8Set2n/Yyedfcz09eY1OReSteydU=",
            "cpf": "U2FsdGVkX1+JVH0Eg2GWSKyqHquDD4lSeqFjCqaapFo="
          }, {
            "num_cand": "U2FsdGVkX19JX6ujM748dbDyVGCi7AYHIVScKhOjLUI=",
            "cpf": "U2FsdGVkX18PD4EjcBY6R2a5j5XoM1dYH32Vb6aatrk="
          }, {
            "num_cand": "U2FsdGVkX1+1YzF+XWcS2to2jdCeW/Ccf/ZhB86E7mg=",
            "cpf": "U2FsdGVkX1/HGWGj35j+Z6DLMZoDXeDKLSQ7nnsLMNw="
          }, {
            "num_cand": "U2FsdGVkX1+MqjL2qtE2gOjJAYfL9fFoQTVT/9qFyRw=",
            "cpf": "U2FsdGVkX18AHAv66DxmsLYDt9ywPEPmLfBMkbgzXog="
          }, {
            "num_cand": "U2FsdGVkX19BHErfDMWi/yKaLB8mB1UGy2nZGqYJMao=",
            "cpf": "U2FsdGVkX19j0AhWzwAlSoc6i/ZQBjp5BakvBym55OY="
          }, {
            "num_cand": "U2FsdGVkX1+Fy84elrufkCdFR8Qx7UWNFLbkDxXXcMA=",
            "cpf": "U2FsdGVkX1991gCOZ35QkvDEBm+LpzfT8b7MIcW5utE="
          }, {
            "num_cand": "U2FsdGVkX18QPCL2uVhMt+nk196oK8HJ7diqxLo6qCg=",
            "cpf": "U2FsdGVkX1/j1MQ1CfQFP/vO8Hjvx285uJrNchpCSSw="
          }, {
            "num_cand": "U2FsdGVkX1/xifJffJC15/NYmBDi+119Xyj9AhK+oXY=",
            "cpf": "U2FsdGVkX18PutNjuLkD/rKbAmaMettZ7yryZdjG6Hs="
          }, {
            "num_cand": "U2FsdGVkX19wwT6bu7AVbRmIiTYDu1ZfBZArMZgeQHg=",
            "cpf": "U2FsdGVkX18pjn1M5eyHoXp1qyzDCxvoRY1wc/OAGTc="
          }, {
            "num_cand": "U2FsdGVkX1/C06g2zK1cB2L4AVLJ/8GPYqiN/sGoEf8=",
            "cpf": "U2FsdGVkX1/v2m+q2PAkWE7uRelUdHlUwGuerfUY9+o="
          }, {
            "num_cand": "U2FsdGVkX1+Zg7SlzrjIRzNcCWF4bBwWbQ5FB4JkijQ=",
            "cpf": "U2FsdGVkX18isL7x75GQnFdzviQWnLAB4m0Ojn2zeJM="
          }, {
            "num_cand": "U2FsdGVkX1+4FEBVcrFHrvRsSph7NcOvy55nyw1L/Rw=",
            "cpf": "U2FsdGVkX1//FbRr3ey/x6yfp6SEZ8gkqzNxDPwOYqw="
          }, {
            "num_cand": "U2FsdGVkX199HP/f+IqhycysXa8t54K92t1jRkp/PQM=",
            "cpf": "U2FsdGVkX1+7geuFxfsDOquLWP2ZsBRTXnoslaXpnYI="
          }, {
            "num_cand": "U2FsdGVkX1+Anz+T0H2G8URWPG4kYsiq23W2HiWGhHs=",
            "cpf": "U2FsdGVkX18De8W3ce9iPXZbRTDW+YB0NOQLtstiCI0="
          }, {
            "num_cand": "U2FsdGVkX18a4sYdrRmQIescyUmHxj5//vIlRCm2J2I=",
            "cpf": "U2FsdGVkX1/E/KH/+0xwi4Q/eOPGBISXR/5k3vYsYlo="
          }, {
            "num_cand": "U2FsdGVkX1/TyJjlAv4FMVOwszEBaSgIIbNQQZwHO+s=",
            "cpf": "U2FsdGVkX19zoQpguUEtCsqIjhZZfIG+SrbHsl6G8T8="
          }, {
            "num_cand": "U2FsdGVkX1+2kMOh0mSFe8zNmNv0Igp+90GorqyvDOM=",
            "cpf": "U2FsdGVkX18vwrkUJN5z1nVXJCHEcr2NVHbi3tFwUuY="
          }, {
            "num_cand": "U2FsdGVkX1+1zo5N/ZIsQ6m3+WETLqwa+Ay2xxZxxd4=",
            "cpf": "U2FsdGVkX18OksujTT1rQQAGsyJrWDFRAFfHCLu3HqQ="
          }, {
            "num_cand": "U2FsdGVkX1+SfjeBBkv6jdIX+W9eYMOlgwdJBPrtf7o=",
            "cpf": "U2FsdGVkX18/VdigFn8G3cjC2/Rew9Sr68pRFgHo8y0="
          }, {
            "num_cand": "U2FsdGVkX181X/rPH5Jf7d03SPB6a6FZ7BvX18wzSV8=",
            "cpf": "U2FsdGVkX1+11MVKurAX/LWg26VOc1gXCxGG5pM6F/c="
          }, {
            "num_cand": "U2FsdGVkX1/ipguloj0WGI4Y23DyxAx3dvAxwDshclg=",
            "cpf": "U2FsdGVkX1/Cnua0WfPo9GIr8nMGEgo7447AshPJhJ4="
          }, {
            "num_cand": "U2FsdGVkX1/CngEEXNacdiH42j4Ty1w5sK8HCwFxVvg=",
            "cpf": "U2FsdGVkX19qVuFK2FJtzeQ5N8H7q0Qne5cgAb4G4GI="
          }, {
            "num_cand": "U2FsdGVkX1+zXPhHukIwLN8l7d/+yK3sFjJYn3VcnNA=",
            "cpf": "U2FsdGVkX1+apq91Cl03oEDtQg9k4j9+0Ci7B1U60AA="
          }, {
            "num_cand": "U2FsdGVkX1/cNJRacgtMGEoEmVeXWV4ubW40kcZkOQM=",
            "cpf": "U2FsdGVkX1+Jz3Q+miEwBJvcUf22pObsKVXt3nwV4bs="
          }, {
            "num_cand": "U2FsdGVkX1/zZKcCgySS2E386heOz9Gtd1ISicsBrQE=",
            "cpf": "U2FsdGVkX1+ULxesTJCnB0ewxoivMpxir/v/Q3SHDPc="
          }, {
            "num_cand": "U2FsdGVkX1/Vo9eX5UaYiH8/mutVlGpjTCclOqOz7A4=",
            "cpf": "U2FsdGVkX19lT+sIOCvp6p7CtryObXzh5RGZQEN5m80="
          }, {
            "num_cand": "U2FsdGVkX18kiqi103WhLWvZz5VyuV7aS3PwHmmTdo8=",
            "cpf": "U2FsdGVkX1/otHm/9m+53mf6uU9ibXRL4XJykamZIl8="
          }, {
            "num_cand": "U2FsdGVkX1+kD1fH68DDq5dYzRNR9DNr0owHoeTEtbw=",
            "cpf": "U2FsdGVkX19rYTzYss2TDQHeMrKMVoyrytY6ShDkLTs="
          }, {
            "num_cand": "U2FsdGVkX19PXc3sRhFm44+1UDrMhgB8v6r7KkQ7tJE=",
            "cpf": "U2FsdGVkX1+AGJU1NfBEjTYD32v4Y9sCfiZ78THNOWk="
          }, {
            "num_cand": "U2FsdGVkX18IgETnBlaq9Nsk1jJREbyN5oxJvZZi96w=",
            "cpf": "U2FsdGVkX1/C63NT0ZyL1j6FsWDErGiGk7DR5pyv2xw="
          }, {
            "num_cand": "U2FsdGVkX19ABm7h5+umTFBONcMUyNeFJ4zIMtVMiiw=",
            "cpf": "U2FsdGVkX1/9lvkEJEza6s/ARU4TIM16wXXtLfjuP+s="
          }, {
            "num_cand": "U2FsdGVkX19NpVtkt7uSz1sAMh4oGTfD0s+KGJeCh+U=",
            "cpf": "U2FsdGVkX18r2nwIO7+x/dWes6AVDq68HndOe0TzWb4="
          }, {
            "num_cand": "U2FsdGVkX18FQ1MlImUQp95yNDiI8GofnzXlqHUEK6k=",
            "cpf": "U2FsdGVkX18yCjRA6ruAmKBt+ncWD0VWdxnstMqTUMw="
          }, {
            "num_cand": "U2FsdGVkX185GeQO+4/MN9SevM+6f6nHRYvZBYwyaio=",
            "cpf": "U2FsdGVkX18+SrBoF5WPDbcHSjTHKnfWBacI4v6Kqg8="
          }, {
            "num_cand": "U2FsdGVkX19DU5ouyCkccmE4MhZZloOtIBlmGqM7GSA=",
            "cpf": "U2FsdGVkX19BN6dPGh2vSVOEhw+wBYj5VjWyBIsCROQ="
          }, {
            "num_cand": "U2FsdGVkX1921NLcX1CndoM12Rn1tgf0KQYsIjs6RbY=",
            "cpf": "U2FsdGVkX1/aiSOmMboo7+weEY+lmAYT9MG1P0LaL1k="
          }, {
            "num_cand": "U2FsdGVkX1/VA9w8LhWi9BvmOENpJrKUXekeRiG5qFM=",
            "cpf": "U2FsdGVkX18vrdSSdxNzkPj7TnuTSX5tWKqnLnltCzU="
          }, {
            "num_cand": "U2FsdGVkX18AIyEP3YwabTuNvZNhptdcWQ2rgE6VdQk=",
            "cpf": "U2FsdGVkX1+kXPJ3VkVnc23rKny97mifuzU1iFes2vM="
          }, {
            "num_cand": "U2FsdGVkX18TKvnOmKOI64AOT37SjMwySD0tlROtHmo=",
            "cpf": "U2FsdGVkX1+Qm3KrQdp8GeAZGAFtwS0qwCebuyeW/w8="
          }, {
            "num_cand": "U2FsdGVkX1+jYilZ8cGm4kyKQNiO9Gfo7RVJtjNGBzg=",
            "cpf": "U2FsdGVkX1+KtyrwFZdtu50/WRn8MUXMkLAwnNt7zd8="
          }, {
            "num_cand": "U2FsdGVkX18zIVQpDWJpjKGahtIb4dKvwNCO9HZMdXk=",
            "cpf": "U2FsdGVkX1+xvkJWF9iCY+x+I+gPPui02ruA0KINK8c="
          }, {
            "num_cand": "U2FsdGVkX1/UeMEjpxQ0+Xm+aSCRMoxPdR6LSDfZ8VQ=",
            "cpf": "U2FsdGVkX196Wk0pq1vzu7NHnFRylGPZeWv9F7Tra/o="
          }, {
            "num_cand": "U2FsdGVkX18Kd7ftsWrZJcvfXLaW2NI+0+6bbaPZGRI=",
            "cpf": "U2FsdGVkX18hkG8kw6bIbs1rpI6Go5fYhSAN4+ZYq7k="
          }, {
            "num_cand": "U2FsdGVkX19t6BMWPQrZ3SQFyq2yk/LQHZtUx6cYnu8=",
            "cpf": "U2FsdGVkX1/Hh89bc8Ntjs9qT+ljtIbMKi7+ARULLkQ="
          }, {
            "num_cand": "U2FsdGVkX1+NBSH/6m3dFRtm7HOrRQwZWa9oZTicxeM=",
            "cpf": "U2FsdGVkX1+4V3rdWNCGFbyVQ4wtW8ObSNbp/h8TH7s="
          }, {
            "num_cand": "U2FsdGVkX19V7WdKuV4u87R5cmisxkMJLcln42h5nJc=",
            "cpf": "U2FsdGVkX18H9zWM0LocHAtbq2lF5huJN74vyKykZn8="
          }, {
            "num_cand": "U2FsdGVkX19YzpliGHWPqsc7CH1St4UAgMwFWEB4qWQ=",
            "cpf": "U2FsdGVkX1/3rOEyEc2TgccIGF8n3Udjo+DKRHJC2qk="
          }, {
            "num_cand": "U2FsdGVkX1+byFc8CN1UDM4lOhfhVK8ymcrgRDOYX5s=",
            "cpf": "U2FsdGVkX1/uBswIpHCGsNrOQrXNHNchKF7uIusgYTI="
          }, {
            "num_cand": "U2FsdGVkX196h3SwcTOIk+ege9RJ1+JfvDeIvmbmeiA=",
            "cpf": "U2FsdGVkX19S3t7XpSqzXjWEgoYUgu9tkSzL504fQi0="
          }, {
            "num_cand": "U2FsdGVkX1/neWoiJDyTl2QSfsgdLcI2DZwTJ9hODyA=",
            "cpf": "U2FsdGVkX18V3cBy0HgFdDT4xgbOUf+ZMv9BL8XtzTs="
          }, {
            "num_cand": "U2FsdGVkX18GcYaEBxpDVDcZO5Fr38OTf5DgZKd2ERM=",
            "cpf": "U2FsdGVkX1/q25XhrYxTJHoM8ZMG5Onko2GWdEHYFlM="
          }, {
            "num_cand": "U2FsdGVkX18bBMq/DEgZSEv8SG9/BynZwDjpr/LAZIs=",
            "cpf": "U2FsdGVkX1/WPp7jcPnnwfOVbwOW52sc7UUBYjTHATc="
          }, {
            "num_cand": "U2FsdGVkX1/kmJ+ro1JyRuNSNPxlJ/l80tKMwWGekGg=",
            "cpf": "U2FsdGVkX1+HpIcHVH857QrzoZnzMqAFKHN3jxwB9UU="
          }, {
            "num_cand": "U2FsdGVkX1/G3B9y57Egzd17RVY+ftseBHAoAjrzI7s=",
            "cpf": "U2FsdGVkX18caw1eoeMMc28rIGIDZiliHU9rhEJ1P0U="
          }, {
            "num_cand": "U2FsdGVkX1+7WNUPAad1N7MVIH76STILafAw3kPEPOU=",
            "cpf": "U2FsdGVkX19E8x1LvevbdRZFEGRMIySh0awKNp8SA8o="
          }, {
            "num_cand": "U2FsdGVkX1/26qJH0TpjEMOuZL9FhirIlDUv7+erk94=",
            "cpf": "U2FsdGVkX1/uuVRPRb+XoaKnDRiepDS/j8PDSEereKw="
          }, {
            "num_cand": "U2FsdGVkX1+i60DDbrWm9zwR6H3toJcu6EPI51TK7Hw=",
            "cpf": "U2FsdGVkX18JRMbMeI6r1blZGrST9BtHYoUwC+/RaCs="
          }, {
            "num_cand": "U2FsdGVkX19rfBFNEWzs54PX5aT3nd+wFxytWGxAezE=",
            "cpf": "U2FsdGVkX1/C3qScses6yG/PU+fJXmlIRIdlnYlVlRE="
          }, {
            "num_cand": "U2FsdGVkX1+ZErnHYt0EUJs1YaqzNKcAZxekYusRVQg=",
            "cpf": "U2FsdGVkX1/27uUXi3GzkP3Fq6YU9W16TDsVPXYbS20="
          }, {
            "num_cand": "U2FsdGVkX1/K+OU8LJcLLCJQi9947OS4acYOMd5x4r4=",
            "cpf": "U2FsdGVkX19lC33jl5JEdPrBLluFvsBEQMR+IXteYCQ="
          }, {
            "num_cand": "U2FsdGVkX1+E8rj3M86BFxr2djMx6ymiglB6x0YJ7VE=",
            "cpf": "U2FsdGVkX1+qYNkOenAe8PNZSL7UDNAOI8Oh7PF6wKk="
          }, {
            "num_cand": "U2FsdGVkX1++r/WDxIEFsT6ENrKmoIB/8U+YAQx9hf4=",
            "cpf": "U2FsdGVkX19NFL0EUCkdovBruOpcFCuHTfHsWEQN2lI="
          }, {
            "num_cand": "U2FsdGVkX18xu6OUU3ehObjEobgav4nmqD2a1mV7fZU=",
            "cpf": "U2FsdGVkX1+ZGiY7Ge0MBnZIf3e1fMyPJ6O986ZsMDw="
          }, {
            "num_cand": "U2FsdGVkX1+o63gUudc8SYUTePl4iAGimvgTJGYovro=",
            "cpf": "U2FsdGVkX18fN2Jdeal09nLOxATNbRcJml26vyzNHRs="
          }, {
            "num_cand": "U2FsdGVkX1/sd12B2oU1qhYZ/heZKSPxB6W21IZha4o=",
            "cpf": "U2FsdGVkX1/KmPSHO/bTCV9h9qzed2UDyjkUlAZ4paU="
          }, {
            "num_cand": "U2FsdGVkX1/jAdWHK69ofwH93IRBI+v1fQKP44wYzeI=",
            "cpf": "U2FsdGVkX18VUV/BfFOEf6eAsKGp0xzWsVW6UkpjFAM="
          }, {
            "num_cand": "U2FsdGVkX19qGiofiEUAgMrsma74zWbKdKKpoAcIutY=",
            "cpf": "U2FsdGVkX18Eb1clWxrFjilFsurmZF6hZIZH7+OnKBY="
          }, {
            "num_cand": "U2FsdGVkX1/1+aw+fJAw1hzS0I3AX2nQwOIOUZ2jknU=",
            "cpf": "U2FsdGVkX18DWKsNxhm6TZWZfdVxU0rPJpn13SrDahg="
          }, {
            "num_cand": "U2FsdGVkX1/wjMjUpps8Bb9A1w0prsLlvY9exbKgtPw=",
            "cpf": "U2FsdGVkX1+bnbJBd9i1YJqFO2xxtth/MW0PIlj1uEg="
          }, {
            "num_cand": "U2FsdGVkX1+X4yvBC3Yr3BLrfjPimDuTWldRnDurkH0=",
            "cpf": "U2FsdGVkX19AwQ6ZO6R0HHSyvJTOh2vqpma1/NjABC4="
          }, {
            "num_cand": "U2FsdGVkX19iznP0CiCO0sHTEHjD4LP0UKnDdSfUzik=",
            "cpf": "U2FsdGVkX19dNNt9sFIQokGhzZFntTqddgllKDVfSBI="
          }, {
            "num_cand": "U2FsdGVkX1/ZdTZRumdNga0LWIjGBXiIkuPKMU/l+tQ=",
            "cpf": "U2FsdGVkX19aFf6rQtLWtmeDf+ujFAQnQtbnqg19pt8="
          }, {
            "num_cand": "U2FsdGVkX18cAyZL5mBKlq1EiO5TXd/EYfohH0u409I=",
            "cpf": "U2FsdGVkX19pFk8A11DqiQ6IzPwTKufL6sS4nzklhPI="
          }, {
            "num_cand": "U2FsdGVkX18QTijUTjrda+TgTVwvgRULcLlnIxN0Log=",
            "cpf": "U2FsdGVkX192IG4IyiMNHyhn1/kTSYz+3anm54oLofM="
          }, {
            "num_cand": "U2FsdGVkX1/SKslIEHdq0j4GK32SXpwqkm1fwEppEJU=",
            "cpf": "U2FsdGVkX1+kdfh81X/ITmsQCk6+IK6tpG5/n865+aU="
          }, {
            "num_cand": "U2FsdGVkX1+lPo1uNFYVZZXIk75w/fgydQAxGNNzD3o=",
            "cpf": "U2FsdGVkX18qTazY50Eva4/F7a8eCO38LtFt/BxDGBQ="
          }, {
            "num_cand": "U2FsdGVkX1/hEXINSRUaR8QETP93a/8y4L5ctUqip8A=",
            "cpf": "U2FsdGVkX1+DQeXb8UK7TNEP7sdcdVeOUXS+tcKbxWw="
          }, {
            "num_cand": "U2FsdGVkX19gwm69C+rhwqi90h+LpHn2poJ1+iJ14xc=",
            "cpf": "U2FsdGVkX1+Jg8wvOo2T7WmO6TchZmn5gNoiE1rJFHA="
          }, {
            "num_cand": "U2FsdGVkX1/9D44FXqi+axBFYx5A33djf4yZz7+pE6U=",
            "cpf": "U2FsdGVkX1/Ar75pFnSVb2Ou6cpFgQGC0tuMS/GJ2js="
          }, {
            "num_cand": "U2FsdGVkX18dFEM177Uy6NkSuIs3EfRdmtQupeyScLA=",
            "cpf": "U2FsdGVkX1+7bBBrajomiTtVDdgwh1M1sOJSWFh8FMU="
          }, {
            "num_cand": "U2FsdGVkX1+CrjRAIWrdSZ5HcIjei3TjAjONJpgTzZU=",
            "cpf": "U2FsdGVkX1++jEgRF7+m9SFKKkER799PvMXel1OXK6w="
          }, {
            "num_cand": "U2FsdGVkX1/rPsG59snGT9hnCjf3DioQAVAeg1QYlu4=",
            "cpf": "U2FsdGVkX18PaHvsqIELgOaujdXVSO/OeUWJVY5/YCg="
          }, {
            "num_cand": "U2FsdGVkX189HMCkhV4sYZALP/eBYrzqD3jOXmzeRaw=",
            "cpf": "U2FsdGVkX19ZLwJOUs/+s1g7TpZYamHT5sYgcD0OG8A="
          }, {
            "num_cand": "U2FsdGVkX1+fqxiQh24nT8qhegfAD2jdAjn6cwh4W1c=",
            "cpf": "U2FsdGVkX18FI9sOZN/aSchcM40GXRnz0mHUQoKpwkA="
          }, {
            "num_cand": "U2FsdGVkX1/GXpfQud7/B4BF7jsbLwXSBgPBvFcROxU=",
            "cpf": "U2FsdGVkX1+G4XswNhFOKN87yDKtITHKzE8lKFMol2Q="
          }, {
            "num_cand": "U2FsdGVkX19YGI59Fn9HUhInfbC7P0HQFF0wNX2j/eo=",
            "cpf": "U2FsdGVkX1+z9VT1zihaqEC0Mfl2R+mBv0VcF4+0Xcw="
          }, {
            "num_cand": "U2FsdGVkX19Owdh6eII+PslCtL85DXr6M6LlJCgpBCM=",
            "cpf": "U2FsdGVkX1/Pja8YTYnPU54xUrX+oPqUCKAd3f2p3Vc="
          }, {
            "num_cand": "U2FsdGVkX18ZWF4Oa37nJGZI6uycWwd4tz90+VjFPL8=",
            "cpf": "U2FsdGVkX18R3NV5tcPHaR7uCapbNuqPjcY/RSZHQFk="
          }, {
            "num_cand": "U2FsdGVkX1/+rimw+KEQcSmF1+ONL71rXfoQXds3XZs=",
            "cpf": "U2FsdGVkX18lGvREYmVg7LrZWIoUXce1/3C5yNNwigQ="
          }, {
            "num_cand": "U2FsdGVkX1/d10H3+Hu1mpbnJN1NdWnMmrjjbt1FehA=",
            "cpf": "U2FsdGVkX18JqkMfdkkGue5aefmnbC3vuO1pf85AJBc="
          }, {
            "num_cand": "U2FsdGVkX18G9bce72JUmGjSIMhTmJ7hMwHW2Nixg7I=",
            "cpf": "U2FsdGVkX18YANXRJzGetl3zq5uF25LrfieIycAubTw="
          }, {
            "num_cand": "U2FsdGVkX18wcwmgIueeKtavYx2tZb0X+yvtwrJ/mb8=",
            "cpf": "U2FsdGVkX19vbE9i/8xCPCry7N/7AZ8Z64IouZBaGh0="
          }, {
            "num_cand": "U2FsdGVkX188VRlj8/5+sfcr5EdQ6xoY6vOc0SR7Wu0=",
            "cpf": "U2FsdGVkX18YL5530eQK3woZ7ZMECaita8Nd/IoFPx8="
          }, {
            "num_cand": "U2FsdGVkX1+h2/NisGmWIKAhvuFx+bK0T9FgGpuW4hE=",
            "cpf": "U2FsdGVkX1/rDbbaEvjSWlLn37T6sLm3Thlri3toztE="
          }, {
            "num_cand": "U2FsdGVkX199gK543QpgAwKJ+PPIVJJP0gBigZxmDNM=",
            "cpf": "U2FsdGVkX1/edkXmGFzAznMFASEww6pTcgDpmXlnBjE="
          }, {
            "num_cand": "U2FsdGVkX1+r5l72iSf9uwTPz/RuE3SitQKzopkpviQ=",
            "cpf": "U2FsdGVkX1/pve8FusBZIECYYLpo1zBPCKf3VPJ/quI="
          }, {
            "num_cand": "U2FsdGVkX1+n9OND5cAz+0/qUCExXM5VtUWGnq5gYAA=",
            "cpf": "U2FsdGVkX1+UcRVkFNA8s/z4Fin5xK7YgnNGTHqey2g="
          }, {
            "num_cand": "U2FsdGVkX18nK0iYt+BjYqfI+PLCqMWv898GD5rsUI0=",
            "cpf": "U2FsdGVkX1+C0ufZT6VljEpvVb4cWm3C4zElZ4vgmpo="
          }, {
            "num_cand": "U2FsdGVkX1+el/2w70CEs3TDID3ypYOV8wYSsEukeUQ=",
            "cpf": "U2FsdGVkX1+7Kl+5z6d3FRbRdZrAAR8OYsxSs7IgqBs="
          }, {
            "num_cand": "U2FsdGVkX19CWqeKl1ppBVQZyGTztyZceJTGCYbSq0A=",
            "cpf": "U2FsdGVkX1+K7Rmt8eXDMX+i82E+0TO7qkSaWFZYJ0A="
          }, {
            "num_cand": "U2FsdGVkX1/7Its/3Db0KvGmnczvIa0QaEu+ebc6/1s=",
            "cpf": "U2FsdGVkX1+G7VpdNnAjxWawxJAU7FBFzf34rM2qUU4="
          }, {
            "num_cand": "U2FsdGVkX19UcGCyP94oliofzZ0q7TrN/JlDr2f85fg=",
            "cpf": "U2FsdGVkX18P+YJpqRzwA2zspxIc6D3GiFupZVoMgBI="
          }, {
            "num_cand": "U2FsdGVkX1+HY49MSVg3+tRugM4N+UwJ5Nc0uX2BQhg=",
            "cpf": "U2FsdGVkX18fHN3ckaCcgrqGJx0XwQh3sL5Z+rfOE2w="
          }, {
            "num_cand": "U2FsdGVkX1+RWS/9vbHHm6WMSHEje8ekShGNkXgj37U=",
            "cpf": "U2FsdGVkX1/uMWAoF+IAUL5jU8rIw1nJIRYIRSHsf8k="
          }, {
            "num_cand": "U2FsdGVkX19RaJFBNpGCu8J6gJeJQ8gWonD7kKjUe0o=",
            "cpf": "U2FsdGVkX1/N6KXrrgHYVDUtpMcPCYrliJv/Ifwd8ZE="
          }, {
            "num_cand": "U2FsdGVkX194eoMYs9bdWN+/JAhke/hfkBKRHUKtw30=",
            "cpf": "U2FsdGVkX1/uJN3myYsSQVI4Chznor7pLrmwYW1CO1c="
          }, {
            "num_cand": "U2FsdGVkX1+oZfXoefeH/RRTMjVktUSRmDX7bbKeZWk=",
            "cpf": "U2FsdGVkX1/iwQ+Vp1U03s8scBbHaK+ZhpXH3T42l34="
          }, {
            "num_cand": "U2FsdGVkX1+jQhrJIBY3Kt5Kz9ipw5QnxR2TN7rAYKs=",
            "cpf": "U2FsdGVkX1+3biYfUZ8X4RL67t1OuNpP4GLii+7nK4E="
          }, {
            "num_cand": "U2FsdGVkX1+/K9nOt3RG7s0UUwnoi59IhICIrscafcc=",
            "cpf": "U2FsdGVkX1+SSYdEusSe3XmOQImn6LXBJFC/aSjW+E8="
          }, {
            "num_cand": "U2FsdGVkX1/Dmro+c4Sx6UM/u4SMPzIiR9MMzEE7tpY=",
            "cpf": "U2FsdGVkX1/xH4HE/NNoQ6pBu3xI9FSOVWoAyTTvYv8="
          }, {
            "num_cand": "U2FsdGVkX18cUwG2wMEw6r5eKJLRk5ZCSyLLTr2dD9s=",
            "cpf": "U2FsdGVkX19ngmoTZN86giXvy9ZIH2fCBeRGSk0wFqk="
          }, {
            "num_cand": "U2FsdGVkX1/fdhSLnTYjheB8ItxMBPMbVopkfABcvBc=",
            "cpf": "U2FsdGVkX19fWQP81psU52u03ugnb7e48NN+GvDhr2I="
          }, {
            "num_cand": "U2FsdGVkX18Q1ppTKpDQFmkaB0AYpV1rcM2lX8By7to=",
            "cpf": "U2FsdGVkX1+fANyJZIZ6vfL1gJAq5j1rwnfacZNnOCk="
          }, {
            "num_cand": "U2FsdGVkX19iq5G8cCLwcEt9hM8QJqQSeaWTJ2YF2AQ=",
            "cpf": "U2FsdGVkX1+L92SXwjfuiOVUrvM1kbT2N4H+UVBpLlg="
          }, {
            "num_cand": "U2FsdGVkX18ty5gofMgxx2c5Zhtb3Q0W5Er4JLjrhOM=",
            "cpf": "U2FsdGVkX18nTqyKmntZWbwhjkxYgeAsoyOgQrHQR9U="
          }, {
            "num_cand": "U2FsdGVkX19NqbkUf4sda0T25mKYfoEKwO0Zd30hIew=",
            "cpf": "U2FsdGVkX1+Vu58Se9V9Pt3hSVqCPlgpm4s14OxtiAE="
          }, {
            "num_cand": "U2FsdGVkX19VpajLjf6QlZi5OuqT33b8ow6GWkFXoA4=",
            "cpf": "U2FsdGVkX1/HOAUJvdMBz4vyktcdyKm3xugN/bAuan0="
          }, {
            "num_cand": "U2FsdGVkX1+NIKNpsqZXgen4sjvymeEKizldmEt1Nh4=",
            "cpf": "U2FsdGVkX18hKrJaFH85cg5N6xBKFb59EokBt8MD0Jc="
          }, {
            "num_cand": "U2FsdGVkX1//jLt3f5MdXKRe6L/zGHhUC7b5mJOiXWg=",
            "cpf": "U2FsdGVkX1/ImyTcKOTorpC8m5O2bPqmMHgA88d78Nk="
          }, {
            "num_cand": "U2FsdGVkX1+8lVxd562uladv1fqscaUSGTsiG8m9DvE=",
            "cpf": "U2FsdGVkX1/i96PLMDUEezdbQSo/G5QyeYsxkeUORUU="
          }, {
            "num_cand": "U2FsdGVkX19tX3gu1FaYBjoQ7xSuswFk5ArhjfQPmYg=",
            "cpf": "U2FsdGVkX19c8ulgGUDHuuEfLesek5GWd8LndpVpX5c="
          }, {
            "num_cand": "U2FsdGVkX1/ZW+x1CANAZ1TGiov1fzOpnoiMQLz0M1E=",
            "cpf": "U2FsdGVkX1+EEPbPvpDooWApufZd7D6mXiB3v8I2CIk="
          }, {
            "num_cand": "U2FsdGVkX1/VFOkJJzz4WAyHm61LPBWyIrv3BRiCMbw=",
            "cpf": "U2FsdGVkX19ljP0k+tW4S1TNFKvWDDWpxHhqvvDseK8="
          }, {
            "num_cand": "U2FsdGVkX1+gVXAvt6XlHT+ALLWK3bEAkMQv1dUe72k=",
            "cpf": "U2FsdGVkX19LJKcoUkFVIYpIZL+4zeFH+InwP5bQMyk="
          }, {
            "num_cand": "U2FsdGVkX1+Kgy9Epe6Y3ngaX/6ih69IKrzS9BfqIts=",
            "cpf": "U2FsdGVkX1+VkjXDBCQM7mDqpTUhnbLSTFTD7i/fOFs="
          }, {
            "num_cand": "U2FsdGVkX18PVxOh8/MDlcHkpAj+E0NRsMfyUeiNVkQ=",
            "cpf": "U2FsdGVkX1/DTIab2FvguGQLWMw/zpS06LOFxPoU8i4="
          }, {
            "num_cand": "U2FsdGVkX1/pHev7KfB042j+gSA9q6JMLiBGsOX1vQs=",
            "cpf": "U2FsdGVkX199IBjSXoLxsqQGknckUpeUVq6fq8+SUNE="
          }, {
            "num_cand": "U2FsdGVkX1/nvrF6LnUMU4FNCuE+9vKf6GjHSUEbVow=",
            "cpf": "U2FsdGVkX1+pQQhPSuEJcyO99P9tsuDGbdS9xJ162h0="
          }, {
            "num_cand": "U2FsdGVkX1+dpvrwgxJLxH7NRleZSaCMqjOqAPjfEjc=",
            "cpf": "U2FsdGVkX181pLq9uLnfs+9IPKYOjfovTBIIKTBX6mg="
          }, {
            "num_cand": "U2FsdGVkX1+BI6MoBCk8U5wg9HZL3qBZ/b9ZUlXIsNQ=",
            "cpf": "U2FsdGVkX18jsMSU09JeyH3zpH+XN9/ngn5zhoIM3eg="
          }, {
            "num_cand": "U2FsdGVkX1+Oq4vMVBrz1Jf03cdM1KFAd6sj+X5LBGI=",
            "cpf": "U2FsdGVkX19brqnAHLE9GAiLLQ5wE1Ri5Itrfg0Gdlk="
          }, {
            "num_cand": "U2FsdGVkX1/hx8YnFtWHl3MYl9XTK0q3ube57QvVkM0=",
            "cpf": "U2FsdGVkX19HXvBKr0PapZ1RlWf12HjGsFryjJ+yqCI="
          }, {
            "num_cand": "U2FsdGVkX1+1Mznkqdx4LUP9KhBmn+Zy1z8nxl3wAgw=",
            "cpf": "U2FsdGVkX18qWDJab2vFgPxbI42wap6jNdtc8KMPDVY="
          }, {
            "num_cand": "U2FsdGVkX19wuU29hvCYDcmbwJADUMMwNfIh+IQUfV0=",
            "cpf": "U2FsdGVkX1+lZEIIJ4yAZKvhQaA1FlZSZ/hQU5dRv3g="
          }, {
            "num_cand": "U2FsdGVkX1/r3mnDdP/xmJCsieXw3nHefsu7ETUlCYo=",
            "cpf": "U2FsdGVkX1/vb/p/0btW1g3P/Kk3jQCvZRscyiu962E="
          }, {
            "num_cand": "U2FsdGVkX19mcpOFVP/ek8y+/PaaBeEuRXA+/B9Z4YM=",
            "cpf": "U2FsdGVkX19VROztK6yYJJXq9Z8E2mgKlPr/OBpWspA="
          }, {
            "num_cand": "U2FsdGVkX19ZGftUkh4JU33mPDGZj7WDDg7noIpZvzk=",
            "cpf": "U2FsdGVkX19e285QY4Hlpp3v244c8VqhHUAV0I3hG6Q="
          }, {
            "num_cand": "U2FsdGVkX1/WyiZdoPIbW/kyrIBUKQ9RPnxlxhoUlsA=",
            "cpf": "U2FsdGVkX18QLQpuZbuVlGs7V8UwBQ6K/kdsVw+EkxM="
          }, {
            "num_cand": "U2FsdGVkX19k2JliA/k1waVCye3xeGsRbZfyspZUi3c=",
            "cpf": "U2FsdGVkX182STF2eubjWB/gMAhtXEV1U5WDeEMmFtE="
          }, {
            "num_cand": "U2FsdGVkX18iOQDvqJLNKIiWgLEzArtyJd6ws4LePMI=",
            "cpf": "U2FsdGVkX18tTY05ZoYfDxwIjcIuwBt4v7Ifxo55ymE="
          }, {
            "num_cand": "U2FsdGVkX1+QUpV6BFVmiLZtZ5xce3BBxESQO5jAYls=",
            "cpf": "U2FsdGVkX18Pgw53hkHpcYQPbcKTRVZiEOtt5pBX1M0="
          }, {
            "num_cand": "U2FsdGVkX1/wGW7H74qm+4xQBD5OLIbuvkWUI6kAius=",
            "cpf": "U2FsdGVkX1/btcqNW9scpkzVBs7+Or0v1LASbE3LF1w="
          }, {
            "num_cand": "U2FsdGVkX1+bkKMJ4IFzuHMKZFs80rII4OfcLv7dKfM=",
            "cpf": "U2FsdGVkX19U31+gj49CPT6X4aw6iegv/IlLHD3EDtk="
          }, {
            "num_cand": "U2FsdGVkX18KnEqStam47J/YOKejFdYWiE8mBhrVid4=",
            "cpf": "U2FsdGVkX1+Q9u6yjiHWirVqFx/pfGdiqRHNl2V2Y68="
          }, {
            "num_cand": "U2FsdGVkX1/3kmwBRUrVYDxc9mZgBBvSntvzAOiCAXs=",
            "cpf": "U2FsdGVkX19fX0ulsoVKjXRdfszpRiZFE8RLQqiQ0ro="
          }, {
            "num_cand": "U2FsdGVkX1/1RDiBqbENY3vOJ1TspUtyDee5jy20qZU=",
            "cpf": "U2FsdGVkX18pKiLEeP2zz1WzCLKRGCI52ef8Ds/cXCc="
          }, {
            "num_cand": "U2FsdGVkX1/wlY/1/NAbZ+7A8q6950k/njSdVsXjJbI=",
            "cpf": "U2FsdGVkX1/GfnqKk8cpzFkhoxWxPJeeU6XQdvoDhK4="
          }, {
            "num_cand": "U2FsdGVkX1894nbZs8X20fSigrP6XVnua6lTTGGceoI=",
            "cpf": "U2FsdGVkX19B0sdgQSNbWQtF1wqbt1PvcwQCJF9DOhg="
          }, {
            "num_cand": "U2FsdGVkX19MPjqb8PR3zb5XYjpVvwM5Xh/IT6FrHgo=",
            "cpf": "U2FsdGVkX1/ECfUgyOkSzFYtPvlsrMEy+LPhJhc4jl8="
          }, {
            "num_cand": "U2FsdGVkX19sL+OzFPsE98foeZmAnSgdiQ4jemXunTI=",
            "cpf": "U2FsdGVkX1+3Il/sPJBlcUIkP0XQZLV2BbJ+/GuGZ8s="
          }, {
            "num_cand": "U2FsdGVkX1+wCqnMcPrkC9eBwFXmNfxHeNjYkdz/DiY=",
            "cpf": "U2FsdGVkX18rmOdnHcjwLn6mECsfUWqvIr89KJ3S5SU="
          }, {
            "num_cand": "U2FsdGVkX1+zMl6IO4q1GdujpN+m8+yTFiFSlQm/ybA=",
            "cpf": "U2FsdGVkX197Vn73dn+AtVC6C45qkx3/vZvdKpba5d8="
          }, {
            "num_cand": "U2FsdGVkX19iMDi+yR4Aq99PHA4S1rp5pGLGnXjnXB0=",
            "cpf": "U2FsdGVkX18OLpMUJ48eZW10HbFuab3fIqPWeZOxo1Y="
          }, {
            "num_cand": "U2FsdGVkX1/XDdGBafFrY7dWxJjFk6eKegu1x1izMec=",
            "cpf": "U2FsdGVkX1/6kCOIhVQRS8tU3SzFCv3xTFjP6B94k+Y="
          }, {
            "num_cand": "U2FsdGVkX1+UPjFKkg3bgTmW9BOQOfZTH5GlZJZ8bLI=",
            "cpf": "U2FsdGVkX18VbUgBS44pi1io3qJWaN7XW7vbuaEwwQI="
          }, {
            "num_cand": "U2FsdGVkX1+c1iJvNsOCP82xLs9InK573GlW71QlYl8=",
            "cpf": "U2FsdGVkX18XtoZdLG6REEDoWRGkmcRlbptkMs8mkHY="
          }, {
            "num_cand": "U2FsdGVkX180AONl15RYGB0FCISpLezocK9Zmpz3sts=",
            "cpf": "U2FsdGVkX19lvtNYLCpb0eUn2MWOHI2wr7tQxINAnU4="
          }, {
            "num_cand": "U2FsdGVkX19BI793PD/oxyvdRVuXCdsGRnn3SZQge5w=",
            "cpf": "U2FsdGVkX19vN9ZTfr2O+myPG9X093E+Iy5gwIZPayQ="
          }, {
            "num_cand": "U2FsdGVkX1/5466N5NMAsA36CFRccA3bkQG5YKuPPoE=",
            "cpf": "U2FsdGVkX18eHcMUjF0tio+ResyTOSS3yBWy023nnJ8="
          }, {
            "num_cand": "U2FsdGVkX18bnkOA3nWRX3MSOlwOJ+6hzYEnvH3SYIY=",
            "cpf": "U2FsdGVkX1+eSCsUaN02ngxf0FMNxHww+Kr8XHn1rwc="
          }, {
            "num_cand": "U2FsdGVkX19Y+P/2E2AMfI0d4Q2A/bgk+Xjkbup6H9w=",
            "cpf": "U2FsdGVkX1+cFhK8JsqjNHGcvbgk774Jw8m9xLSpj1Y="
          }, {
            "num_cand": "U2FsdGVkX1/FxPYl4om9b0yqckfxLAbhDW3GjqFSASk=",
            "cpf": "U2FsdGVkX1+wE6qJUr5a1HYO+y1wk/Xn5pN4kiLXVQ8="
          }, {
            "num_cand": "U2FsdGVkX185QAtkFtPBKHuXHUrXSGkczyAIZEinF1o=",
            "cpf": "U2FsdGVkX1+H3cr0pcTudOp7bgoc9cbtTfg1SuIkv1E="
          }, {
            "num_cand": "U2FsdGVkX1/0tfPMoujTOrcxtz7RHHTMYUk+2gIL23A=",
            "cpf": "U2FsdGVkX18mt2I8E9b87ou319Vm0pk79+ZiAYeKE/o="
          }, {
            "num_cand": "U2FsdGVkX18LTnt21CnU4k5YQgVylosH5/nOIGC0DkA=",
            "cpf": "U2FsdGVkX18xglzgNK8fqS/eysKurU6RmToqud1LvBY="
          }, {
            "num_cand": "U2FsdGVkX19763WLbLA0yeHB7dn8rK/xAWIXfwwlWL8=",
            "cpf": "U2FsdGVkX1+I2rpOYfoNxsAQcsDkrkaaBSUX45XFWUE="
          }, {
            "num_cand": "U2FsdGVkX1+CMVk0MFwnqf54rznPj3kJ2KiBYFcBqXk=",
            "cpf": "U2FsdGVkX1/8vqvjc6Ak3Pa1ODXasJ7EQCLu+3djBJM="
          }, {
            "num_cand": "U2FsdGVkX18yriDnukUGSpt4uMMto3zSNmcqvcNDrEc=",
            "cpf": "U2FsdGVkX1/lk2zJHRLl05WLZU0zP4PPecKu0MH9W4A="
          }, {
            "num_cand": "U2FsdGVkX1/7JYVSWHIzloIauqIrlHqRj39QI5gx44I=",
            "cpf": "U2FsdGVkX1+kS3mdt1H+/d7QcVbzbQEaMamQ2AR4EXI="
          }, {
            "num_cand": "U2FsdGVkX1+1gScibsCbSJibvLjsdv2ZUIl1ohSk3d0=",
            "cpf": "U2FsdGVkX1+YoZoe47GcrjHPBDCSFxcvaDD3rdk80sk="
          }, {
            "num_cand": "U2FsdGVkX1899lOwrB6lu0USJ3h1rTgPqNm5t1xhLbA=",
            "cpf": "U2FsdGVkX1+eczc67pKGyXeLpBbYG79H4pGuXqpWK1g="
          }, {
            "num_cand": "U2FsdGVkX19xe3Kt5RafnYfSDmyG1DPjVQZkOHfbN2w=",
            "cpf": "U2FsdGVkX1/5cly7ueI6i/ySAOKCD6i64/yH75VDnzc="
          }, {
            "num_cand": "U2FsdGVkX1/vMwUBX6kn8TgV6maMo3h2G1n10yhW508=",
            "cpf": "U2FsdGVkX19atckaWkHfRNX1HHm3Bswt+G+SREOjhlY="
          }, {
            "num_cand": "U2FsdGVkX1/1ossZcnIKjlu9YNGrzfxchuvqYHdnRdM=",
            "cpf": "U2FsdGVkX18GhCS+9ANpQW2E8sjKscD2UbSKx6lPuj4="
          }, {
            "num_cand": "U2FsdGVkX19vNmuwfNJf/uZb74ChXrAwpLfkrNfxcFw=",
            "cpf": "U2FsdGVkX18Q9avpEdloiXMUcgulyhF66PWij599ebM="
          }, {
            "num_cand": "U2FsdGVkX198MsgiI2Y3GwBGLRTFXOaGYwRhWIH/YHA=",
            "cpf": "U2FsdGVkX184lcc79MVUQTMJG6zC55EtDuKQaKLHQQw="
          }, {
            "num_cand": "U2FsdGVkX18s2n/3Wtz2Henjlrb3QdN2HbasOWsywAg=",
            "cpf": "U2FsdGVkX1+5hRnrZmd32v5AU+/gHVZjgLX+bGlv/Fk="
          }, {
            "num_cand": "U2FsdGVkX1/g9el+Dw0ftn3WR55WEF4t4iWCWTdg1NY=",
            "cpf": "U2FsdGVkX1/4VbmFlhriBiYfFSmOBhYiV6PEdIW4NT0="
          }, {
            "num_cand": "U2FsdGVkX198Wf+3ZxGY7i/01yzOCCwaf1A7vjK7Vc0=",
            "cpf": "U2FsdGVkX1+q1OUf/+a5mp6PtkgiPtbxgrqCQ8Ovscw="
          }, {
            "num_cand": "U2FsdGVkX1/6AN3koifJwIw6L6zFsvD6zbGkG6FYdFw=",
            "cpf": "U2FsdGVkX1/8mOvHlY+A2G0FcighXKkE/+OioAZ26KI="
          }, {
            "num_cand": "U2FsdGVkX1/8vbw4t11SxQNNZRhelurRySKN6KKNCyI=",
            "cpf": "U2FsdGVkX1+iZKw5KxsrK7MRSe5rK9SS9acrWAd0r44="
          }, {
            "num_cand": "U2FsdGVkX1/fEMgaj4XDPrgoG/Yll7iDxc7BAtE80G4=",
            "cpf": "U2FsdGVkX19OpNKGHAcPaIAqQTSr73/YvUObKGK4/94="
          }, {
            "num_cand": "U2FsdGVkX1/Ct4PoEdLDzkJV4MVp5HKRa99sb01puNs=",
            "cpf": "U2FsdGVkX19eoJ4wWbxQPlb//59BTC1tN9MOzQuJfhc="
          }, {
            "num_cand": "U2FsdGVkX1/I6mDD281jz3j2uuECXiPVmb6W5/WSv3w=",
            "cpf": "U2FsdGVkX1+ELi7oCiJNdBOF0OCQVjQ2srkuJyE79/8="
          }, {
            "num_cand": "U2FsdGVkX1+RsRJV4R5b4ge0PLNL8rfClmjwoIGHuQM=",
            "cpf": "U2FsdGVkX190aF0ZPVYWiVUEsfe8sSh2j6qCsdeMiuU="
          }, {
            "num_cand": "U2FsdGVkX18sc2f/8H0DfCxFfFYN4OqSbMSyQfYKCvY=",
            "cpf": "U2FsdGVkX19EsImsQHWYLK3AF3QyEtZiIXtVBp+nnjI="
          }, {
            "num_cand": "U2FsdGVkX18UxooFm8TSyaB7174RYPucfrpzsFtUSPo=",
            "cpf": "U2FsdGVkX18GJmidxq8MvEjLDQdVZCwjJEesbISP584="
          }, {
            "num_cand": "U2FsdGVkX1+kiyDhN/GwGz2Z6M2jETtI3nOBHBsDIkI=",
            "cpf": "U2FsdGVkX18uPdhAGR2t+sjxQoHKScHKu2c5InaqMKI="
          }, {
            "num_cand": "U2FsdGVkX1/uBSwXI4/R86dUCxHmfNL2hoSNTHfhgMs=",
            "cpf": "U2FsdGVkX1/8j+liYWrIyHpe3JIu2PwcDbig+i8tbp0="
          }, {
            "num_cand": "U2FsdGVkX18ckTW+FEwUdrOG8nmbIJOokN5WonPidm0=",
            "cpf": "U2FsdGVkX18HACiaTqy2GWYpw/HK7Dz7shds6pkDHus="
          }, {
            "num_cand": "U2FsdGVkX18Mlr9QN0MvOF01M6iYZ3Wdfh77RGzL6TQ=",
            "cpf": "U2FsdGVkX1/HBkynoH3J/l4V6Dxq1Wn70kUl8uVDIv4="
          }, {
            "num_cand": "U2FsdGVkX18ZYSJObjWBlOnyXEUBgC5cE+OSxv6xSFI=",
            "cpf": "U2FsdGVkX1/RFJ4Zgl9CNNx5t0id5DGUZFZI7v2YtUs="
          }, {
            "num_cand": "U2FsdGVkX19Qn5BAXMVUAKxUKnns9d1nGtkJ3NzgIJg=",
            "cpf": "U2FsdGVkX19kgSseovqhg+O2aKaZ9J3O+LMAV0cwQw8="
          }, {
            "num_cand": "U2FsdGVkX1+qe6HBX98cN4Zp/2UZ4qOHc5ZjwbUVKJs=",
            "cpf": "U2FsdGVkX18gtwhohBvqNg6BPjJ80UT8iOMxzNohMuA="
          }, {
            "num_cand": "U2FsdGVkX1838CaWVEsKnif/9WcKz0WAkxWJhYjgOeg=",
            "cpf": "U2FsdGVkX1+iYCMFk/rdMoTr/AjdOvUXWIQHpoXbtI0="
          }, {
            "num_cand": "U2FsdGVkX1+LhAokCxvuqujmw1553uPLp/jLviNAAVM=",
            "cpf": "U2FsdGVkX1/eWo3yYxGQNvdt208msjnlvLdrLP5Wq5I="
          }, {
            "num_cand": "U2FsdGVkX1+ieWIl7BlUXzrFC5XmkJW0cddJvhu+zPE=",
            "cpf": "U2FsdGVkX18tk49ZlX1QiypACqKZqckf/ClkieIcLwI="
          }, {
            "num_cand": "U2FsdGVkX18VP7T3thUKksWGzxh1WMESgbIHTP7MUB4=",
            "cpf": "U2FsdGVkX19nkdB/jHbb0zv/8HVkhguh5abvoPsghtU="
          }, {
            "num_cand": "U2FsdGVkX19F4yUrYDbYtuuLyKVxsseyfLvSU2zcroA=",
            "cpf": "U2FsdGVkX18g4+C30KuEUUScAVtFU8NU+rJ8z+JmEZo="
          }, {
            "num_cand": "U2FsdGVkX19RB+yAoy3jsB4z+iMas6CXgIfUebHjP6U=",
            "cpf": "U2FsdGVkX1/S0UWHqyb9w3JtpL5JrCdrE5QUe5TRFOw="
          }, {
            "num_cand": "U2FsdGVkX1/YrON2DGwu3kHacKaPEgGQu67PnmH/FY4=",
            "cpf": "U2FsdGVkX1+pvMAzrr5+kbjxhVv+BbJCC92exNJ3TFA="
          }, {
            "num_cand": "U2FsdGVkX19E3DoHm9NVWjipglQWMKa4dlllEQCfVjQ=",
            "cpf": "U2FsdGVkX1/rvDnABbOFsa6NzDIdnzlmx2s83pRKrkM="
          }, {
            "num_cand": "U2FsdGVkX19XSq/xDs6bipxJGAPDr+FuYLpJHGyUd8U=",
            "cpf": "U2FsdGVkX18gcHZ7OS5S3WxBEe5tIgi9hvasptY7dKU="
          }, {
            "num_cand": "U2FsdGVkX19cXSEeNv9NrysSghdFd11bxp761qwaONs=",
            "cpf": "U2FsdGVkX18HIQMcpA5KKbOMfB5uqXiW7+efxVVsAz0="
          }, {
            "num_cand": "U2FsdGVkX19FQB9pncjIVFCirB/GCbaLtzbHfJY4PJc=",
            "cpf": "U2FsdGVkX1/yQdfqo0yZkwD86tg76XmWkMiFCDUt9/Q="
          }, {
            "num_cand": "U2FsdGVkX19PpxdnHdb2WON+F5cE+QQLVrVXH1Ck4s4=",
            "cpf": "U2FsdGVkX19WpwVYmeW2We0hDbcWA6QYXqso0CG3xDI="
          }, {
            "num_cand": "U2FsdGVkX18j/D8LWYkK8thGEciZXmwTDJFV3O8g0kQ=",
            "cpf": "U2FsdGVkX1905yORCfbmUPClcRJVbuW/Dn5OD8ayn5Q="
          }, {
            "num_cand": "U2FsdGVkX1+Lci/9/MKMMAYaAfdqpTNWGUSLNyCAtOE=",
            "cpf": "U2FsdGVkX1+X2csWD7vSBKqrgNTcpW8jQCiVf76X47E="
          }, {
            "num_cand": "U2FsdGVkX19RbITSzQzEWQ5VewR8JJgTh6de2OHdNGU=",
            "cpf": "U2FsdGVkX1/ES31JW72IFmwt+CZpzHZKWCLE6HCsDMs="
          }, {
            "num_cand": "U2FsdGVkX18Xk5hTrv6RkTf4sYaQtYFsPkJEwH/hio0=",
            "cpf": "U2FsdGVkX1+rwtlqZ2pzAvrJcHbVOeIw4CiaDTS9XUU="
          }, {
            "num_cand": "U2FsdGVkX18uwbBOWnaGLiDy8pvmDVS0PhoKNGRnmIs=",
            "cpf": "U2FsdGVkX1/RkSjAve6s7Cy/1eRTQGuhvM9sMFJyKMg="
          }, {
            "num_cand": "U2FsdGVkX183UjHyny1OEFvLlgPAIDDp+3EmbnnVrEk=",
            "cpf": "U2FsdGVkX1+6bHZf0Umbfdard1hEpVScRb4Bd7a+JHg="
          }, {
            "num_cand": "U2FsdGVkX18UtZDIkibOEnoo1thagTgYNRuga7K4XEM=",
            "cpf": "U2FsdGVkX1/1yc5Pl25bfR5RxvUHPgvHELvYh9bApTU="
          }, {
            "num_cand": "U2FsdGVkX18U2tjEAlgs243fTwywisA/KyumsnZAqlI=",
            "cpf": "U2FsdGVkX1/OZvFtyZ7/Rp6UdayeoHcHN7RybpEsuqA="
          }, {
            "num_cand": "U2FsdGVkX1+UZVVQrlnHtDNIqHO7MrV8XufVAMHdiaw=",
            "cpf": "U2FsdGVkX18afOPGSQYDX2inmSUA2ctGpM7UiHlHZnM="
          }, {
            "num_cand": "U2FsdGVkX1/Zo+6C1oM713RLWPRKbokgPiiy3ZRclh0=",
            "cpf": "U2FsdGVkX19cZwbF0sNMaYDuB/9YhErJ63Qdnxk23iA="
          }, {
            "num_cand": "U2FsdGVkX19vDdMBWdz0ayxSvXi+EZVH94wEpbY/X38=",
            "cpf": "U2FsdGVkX197GjIHm9x0cJ5pg/Txr3V6MSAYoR0RZBs="
          }, {
            "num_cand": "U2FsdGVkX1+UoT3sNXmfIjCCj5AeZEipnTsAbKoPqvo=",
            "cpf": "U2FsdGVkX187c55vE54GQOAA/jZMiPWD64vL2uodQsY="
          }, {
            "num_cand": "U2FsdGVkX18wHgZMG2f2LHItNekZiPaB9WRjhkP6jM8=",
            "cpf": "U2FsdGVkX1/abx8r2AWclBiLPkykpqg+sdo10V8XPYI="
          }, {
            "num_cand": "U2FsdGVkX19tK3Mk6fxgEfFAQX1DOo2i46MEKAXeq9g=",
            "cpf": "U2FsdGVkX1/XK8UmCrfo4cwKlULwFgFIpDfPCK5rGTc="
          }, {
            "num_cand": "U2FsdGVkX18WrqSNCU9JhqqL/RuC1m+HsM1CPO0Yl20=",
            "cpf": "U2FsdGVkX19PCyoATNuMtwAzTROGNxEZ0wzEwf7ea4g="
          }, {
            "num_cand": "U2FsdGVkX1/yhuD5PkDJ1tX6p9c19MTeKRSqq6aO+Xs=",
            "cpf": "U2FsdGVkX1/RmYVbqUlNyaIpQW4RY2511qpPZ3YKiWc="
          }, {
            "num_cand": "U2FsdGVkX1/fj7cEW4YDEH4t8k4Yd8qxTlBWoFnNliI=",
            "cpf": "U2FsdGVkX1+EXs8olgVMdDLP7niPCqVo4sWTZJ2yCHo="
          }, {
            "num_cand": "U2FsdGVkX19w5OGL+2T3RNKK3zCXx3XO2vaerRCGlcA=",
            "cpf": "U2FsdGVkX18EJ+HXgXuB4gv+lfGiWifyD9KyUXxEt2E="
          }, {
            "num_cand": "U2FsdGVkX1+PjM8bZnYI0YhhzMJFj1zn5beYg69JvLs=",
            "cpf": "U2FsdGVkX1/Hd87asUFr9tRzqw3MkfWW0Ds3vg0hf1g="
          }, {
            "num_cand": "U2FsdGVkX186A3IjLeJNSoL4LFI2Aa/TPHKfuw2KuWU=",
            "cpf": "U2FsdGVkX18FoGYeEiHfghXRftzcIj4NqZ2xvoGIXEY="
          }, {
            "num_cand": "U2FsdGVkX1+pyfF/PO/qbLej5ne2y0TeRCwVA4kVaXE=",
            "cpf": "U2FsdGVkX18GZGgpgZg5BkpbvAaJEnlbc5qR/IIMxdM="
          }, {
            "num_cand": "U2FsdGVkX1+T2lmNkpD584m2ZJVoxqJMsVQB+NJp+Jg=",
            "cpf": "U2FsdGVkX18TZxyqMalKNAkQETKHG6RgPSQoisox9l0="
          }, {
            "num_cand": "U2FsdGVkX18addX+c9waUI9OFTvw0E1EmpsVu8eB4co=",
            "cpf": "U2FsdGVkX19rBve88eiGQQ6oM0AsuRN3AeEGF0ADkMU="
          }, {
            "num_cand": "U2FsdGVkX19jNEMtvblz2ACTutpel5asHG2FHD94BKk=",
            "cpf": "U2FsdGVkX1/pKoklNyB4b+/pwFHeMGNZoXhiDHUClj4="
          }, {
            "num_cand": "U2FsdGVkX1/nZu4rFrE5ahYhmLIzmTWyJ4KlzKFCRuA=",
            "cpf": "U2FsdGVkX18vWrOb6o8ptm6sC7rq9alokpKbz1itrec="
          }, {
            "num_cand": "U2FsdGVkX1+xHzGe+RmjVYPKLhlA9foONilNz/h70o0=",
            "cpf": "U2FsdGVkX1/HHk1DH6VrJnoqcUdAoo1+LduLOxobi00="
          }, {
            "num_cand": "U2FsdGVkX1/FRTdCfKTnMfIAZ4IxLXUx2EQ166lVWks=",
            "cpf": "U2FsdGVkX1+VntdFhmHaWkrpVbuESlsiB3W4YUXFlrE="
          }, {
            "num_cand": "U2FsdGVkX18XOmbNdffgsr6K3BEYribGxHWqBbhz96A=",
            "cpf": "U2FsdGVkX1/9JizwRxEH0jqUqL2oieg0nljAbYXgE0Q="
          }, {
            "num_cand": "U2FsdGVkX1+F/RR5zs2gBU+w0ewOomeUYAod0+Fvipk=",
            "cpf": "U2FsdGVkX18vYZOvTIYJq+y9NdBaiTjIj2c6dSK0UTA="
          }, {
            "num_cand": "U2FsdGVkX1+8rDPILsXHtIgq9wTt++87OIfG3OdA3a4=",
            "cpf": "U2FsdGVkX19QW+BeYo1JhGzGssgmms+xWVvNCrHT0Mg="
          }, {
            "num_cand": "U2FsdGVkX18DYePNBRQ9k81gH5O/sJN3fFWOgC1gMxo=",
            "cpf": "U2FsdGVkX194QEh/96dJ0IyYfze+dfv6lOomP3DWvog="
          }, {
            "num_cand": "U2FsdGVkX1+D2/LTyAS1WkkC0tZO1JlTcGPR1DEeG9E=",
            "cpf": "U2FsdGVkX19dbp+CxIYKG3F6GgSSyo8NwzybkbppWRU="
          }, {
            "num_cand": "U2FsdGVkX1+WvB1ZlKC49VBWlWHlrhpA3+HqZRgR2fQ=",
            "cpf": "U2FsdGVkX1/C+Ur1o+pSPjZ/NtxYaGenY9s9cmB5v0s="
          }, {
            "num_cand": "U2FsdGVkX18BzUBzwNpzdARXyEjVzMwfiJmWm/lhaTg=",
            "cpf": "U2FsdGVkX1+2Uv13IoaJEl17uT3GC2PUCyT0zQfMImI="
          }, {
            "num_cand": "U2FsdGVkX197DScY1huvj9VipjnrrCG3wk8YwyRE7x0=",
            "cpf": "U2FsdGVkX1/jD/uZj6g0Yi3G1Hkz48ts2w79ahjcm7M="
          }, {
            "num_cand": "U2FsdGVkX1+BbBTHevZv3YN3Ihi3TrgcSW935Kt0C2g=",
            "cpf": "U2FsdGVkX1+cnH8/jcasr+ckwX5/g//3b43dTwjkG+Q="
          }, {
            "num_cand": "U2FsdGVkX19DG3qT2F8pWRnDZA1tfgcdMTUvRcsD+os=",
            "cpf": "U2FsdGVkX1/0Nw4d9AclKo0302TKysUXsiIeRYM9RBo="
          }, {
            "num_cand": "U2FsdGVkX1+DoEGljqefGUQgSmNh87KpeVHlM+TfnGM=",
            "cpf": "U2FsdGVkX1+8CvaV8/SSZhVmBexmS89lbCsRVfwS460="
          }, {
            "num_cand": "U2FsdGVkX18uk3kwPWoqHBaP0xtCC6/D2/Yy8hHnrhk=",
            "cpf": "U2FsdGVkX1+z64BeuPgGPI6BE28RfTigVZTo5/gbCSI="
          }, {
            "num_cand": "U2FsdGVkX1+tOqBvzAG6udTsTMqMo3B7kHSNaG5D734=",
            "cpf": "U2FsdGVkX19VWwiFX2VKdxPxFaoE5gFOcPaeYoRdx/Q="
          }, {
            "num_cand": "U2FsdGVkX18DwIQSvsZnzi6+MN5hxVZ4xfidv7rgaRg=",
            "cpf": "U2FsdGVkX19rG50FSDlQysk2JO3iIXRpIFeyPLxAuTo="
          }, {
            "num_cand": "U2FsdGVkX1+IO9ZhMBvSgUsBkSoZezXR4CThUb0KJRs=",
            "cpf": "U2FsdGVkX1+84GAWAyNuReLghsS4imVeM5IKIykYHWY="
          }, {
            "num_cand": "U2FsdGVkX19N9KvrytZgmDgvuaAtsXOcrXfL7rTHjdE=",
            "cpf": "U2FsdGVkX18IRw3l04PZ2+bZ/y3K20KPX4azxyK1u/k="
          }, {
            "num_cand": "U2FsdGVkX18jNUwNIGvkupPwBSGvty0LjFGPXVodN7c=",
            "cpf": "U2FsdGVkX19dbMZgdLhxgPDujRZWTHXQlLYq43GexyQ="
          }, {
            "num_cand": "U2FsdGVkX19Tv1jWcNLhwlOErmgNBaX4c7Dg9I8RDCA=",
            "cpf": "U2FsdGVkX1+tl+iM1LtTU1MlRMLX/MIWt5B/a/X8wnU="
          }, {
            "num_cand": "U2FsdGVkX1/M1pOZReucsG5Ey+vdubLHDY9GKY2WlEg=",
            "cpf": "U2FsdGVkX19HjXNIjC9r/bZUi8wweB3Zsff2iA6tGoI="
          }, {
            "num_cand": "U2FsdGVkX18WDYdtwRdAqRXpa7sZvan9JIGTc6quurI=",
            "cpf": "U2FsdGVkX1/zSSNdyV4AQ56H4Du/A7PGAcGK98W7Yxc="
          }, {
            "num_cand": "U2FsdGVkX19o6wVeJ0fs+tikyUUjcJG/X0pshYvwsgk=",
            "cpf": "U2FsdGVkX1+0oGzZtHY/h3R1dN7kqr2eM+J5lmKBQvE="
          }, {
            "num_cand": "U2FsdGVkX182dqNa47qhhvCj7nRS6IOGxxrF96y+/Hk=",
            "cpf": "U2FsdGVkX1/d34xI7G9m67Lsky/sL9BZbHm7H11W2dM="
          }, {
            "num_cand": "U2FsdGVkX18d6nrUy/0wGP8nITfSET6ll6wlnXq+YZE=",
            "cpf": "U2FsdGVkX19DuJQJpM19zMnZJgFg5tC5A6hxRqExWI0="
          }, {
            "num_cand": "U2FsdGVkX1+0L2CxIoZFYCqGpK/mgDF6vRmp1ZBBJnQ=",
            "cpf": "U2FsdGVkX1/JwsmX0XIZ/F+mCgnBGIkLxnnLZawq2H8="
          }, {
            "num_cand": "U2FsdGVkX1+ARD/z9Hh3SK9vw/ofoJujieV2G3mRHpY=",
            "cpf": "U2FsdGVkX1+988u6UoMumvoF7eCI/jg8hrhvE7QjJ/s="
          }, {
            "num_cand": "U2FsdGVkX18lCsODopn6tQwkxt5nvJtHv16DMBgAGiA=",
            "cpf": "U2FsdGVkX1+hvgo5oT2hlZFqEJ3pqjYAVO7GBenoyRE="
          }, {
            "num_cand": "U2FsdGVkX1+8uVUMSPdvbu7Cca+wfHw2kUIiiBTeEn0=",
            "cpf": "U2FsdGVkX1+8Ft91HtUmPMlvdXlmw43CPtlcWcH732w="
          }, {
            "num_cand": "U2FsdGVkX1+UYCi6fxRpX2AR6+9N8EosbdsTqtx/M5c=",
            "cpf": "U2FsdGVkX1+mnzGIQ0k/ROFiJSNoPsqyW+9od9/hqMo="
          }, {
            "num_cand": "U2FsdGVkX1/HAX0YJjVw4I8k0Osey1av1J8xga/+b5A=",
            "cpf": "U2FsdGVkX1/KTCM7Xe5JUqRjAsNiafeSFbcBqrlM4zI="
          }, {
            "num_cand": "U2FsdGVkX1/OLV1mKdOoz2N/EHaCLRcdTMaIbYvCrHw=",
            "cpf": "U2FsdGVkX1+PMRdHst9pMS0EzhY8MueedexeeRSsmkI="
          }, {
            "num_cand": "U2FsdGVkX1+JHucQ1rVB16kz0QaJxUQoy9b5JI6ln8U=",
            "cpf": "U2FsdGVkX192cqkIvy1v4Pz7tB9cVyT1cjIEeby9HBA="
          }, {
            "num_cand": "U2FsdGVkX19Si4L/qYW4pddP7e2T6pK+oRn/m61C56o=",
            "cpf": "U2FsdGVkX1/Bq5y70mTnZTaleOE0HDqxqjHuce3DbMg="
          }, {
            "num_cand": "U2FsdGVkX18TEC37adPwPOlM2oziu/BXhVAtgpy5zAQ=",
            "cpf": "U2FsdGVkX1/rlaWQKghZMZm0MuFnW+x0U1KXd2j6SMo="
          }, {
            "num_cand": "U2FsdGVkX18HMo+8xYYmdI0QFw7u6qCCdxnPveKicT8=",
            "cpf": "U2FsdGVkX1/HYW5ZdzoZr/CKck2bpCxwo/NH4SpmtGg="
          }, {
            "num_cand": "U2FsdGVkX1/rBRL89t//Bq3IhTq30bbWJ96+60BQ+Qk=",
            "cpf": "U2FsdGVkX1+pWv9z2zcsaYVqddl7T5lh+9aLgzwGDww="
          }, {
            "num_cand": "U2FsdGVkX19bMIE6N3DOfYqpazhGZOtWw1wMyhD0m9g=",
            "cpf": "U2FsdGVkX18Zzw52+7k4RcGRcCoHusVy0qGW47imOdI="
          }, {
            "num_cand": "U2FsdGVkX1+REKc+aJNQcIKps/u0bTZkPyYfN5qOuL0=",
            "cpf": "U2FsdGVkX1/Umknfywk38zznUKRwvn5HfiAza7jQis4="
          }, {
            "num_cand": "U2FsdGVkX1+fTWjrZVbqNhY+wb3jhX1jQJulOnmBM6c=",
            "cpf": "U2FsdGVkX18s6dZ6wgkkfnXvub/kB2mS8ICnP+WwSW8="
          }, {
            "num_cand": "U2FsdGVkX19CzV6i2MwT4gwMTp9WzA3CLZlARo/Zuks=",
            "cpf": "U2FsdGVkX1/t2AJyLxynNzKHlmKqP/WZIAKe87803z0="
          }, {
            "num_cand": "U2FsdGVkX1/opKwPS+L/OGYUGfOmIOmxoJVXNXrJzK0=",
            "cpf": "U2FsdGVkX18h1jATp7At+tFu6ADKLcuSeoKrV/xy0t8="
          }, {
            "num_cand": "U2FsdGVkX18dL1Rowp5IGylgtHS6TKQvoprYoxKAfpE=",
            "cpf": "U2FsdGVkX18N6sP8MakGjAbpuv/pn18+1xpcQ6jForo="
          }, {
            "num_cand": "U2FsdGVkX1+p5gWiI4HG7x6pz8muFnbh4XfUnCHLNQY=",
            "cpf": "U2FsdGVkX1+/GJ7zqIq62I0yIJZ6cnqdvq7xfHnQ9mg="
          }, {
            "num_cand": "U2FsdGVkX1/SWXpR5NS8tPUHzJZ2MYvDCEt9EELq6Zk=",
            "cpf": "U2FsdGVkX1/83PifqkL9oMI/n5JE+sQjjLeWYqwLetI="
          }, {
            "num_cand": "U2FsdGVkX18xf4onHbsfchFFTFz1acLYs1W4i2p//oQ=",
            "cpf": "U2FsdGVkX18ljn3ROLXaxJSy2HDbux59Axihirk5rDI="
          }, {
            "num_cand": "U2FsdGVkX1+Nqt+eb98rMXwTUZ8Up3eykD7AbC5RUlc=",
            "cpf": "U2FsdGVkX180paZ7LVaIy1h/sKmTgP9wOaClRBa+je8="
          }, {
            "num_cand": "U2FsdGVkX1+N7vJ30hRHtMLE5zHJvojeo0RvmZB/AEA=",
            "cpf": "U2FsdGVkX1+r7QOtuMfZNzfvojD401r/x1GIdIBlyVU="
          }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2205/2205_recx-ped_inse/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
